import { observer } from 'mobx-react-lite'
import { useDocumentTitle } from '@/hooks/document-title'
import { useActivation } from '@/hooks/view-model-hooks'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { type OCRScopingJobsViewModel } from '@/features/jobs/scoping/OCRScopingJobsViewModel'
import { OCRScopingJobsContentContainer } from './OCRScopingJobsContentContainer'

export interface OCRScopingJobsRootContainerProps {
  vm: OCRScopingJobsViewModel
}

export const OCRScopingJobsRootContainer = observer(
  function OCRScopingJobsRootContainer({
    vm,
  }: OCRScopingJobsRootContainerProps) {
    useDocumentTitle('Scoping Jobs')
    useActivation(vm)

    return vm.sidePanelVm.fetch.match({
      pending: () => <ContentLoading />,
      rejected: (err) => <ContentError error={err} />,
      resolved: () => <OCRScopingJobsContentContainer vm={vm} />,
    })
  },
)
